<template>
  <div class="w-100 d-flex flex-column card-contents-chats my-1">
    <deal-header-chat
      v-if="chat_deal && chat_deal.deal"
      :title="chat_deal.deal.title"
      :price="chat_deal.deal.price"
    />

    <div class="p-1 w-100">
      <h5 class="mb-2">{{$t('creator.submit_contents')}}</h5>
      <span class="text-box-success">{{$t('creator.submit_contents_text')}}</span>

      <b-form-file
        :key="updated_input"
        v-model="file"
        accept=".jpeg, .jpg, .png, .mp4, .mov"
        browse-text="Buscar" 
        class="my-2" 
        @input="hasChangeFiles"
        :disabled="generating_preview || (chat.casting_call ? previews.length >= 1 : false)"
        :placeholder="$t('dashboard.chooseFileChat')"
      >
      </b-form-file>

      <div v-if="chat.casting_call">
        <textarea
          class="size-input mt-1"
          autocomplete="off" 
          :placeholder="$t('creator.textPublish')" 
          v-model="text_publish"
          rows="3"
        />
      </div>

      <b-row class="mb-1">
        <b-col v-for="(preview, index) in previews" :key="index" class="col-12 py-2 border-bottom d-flex justify-content-between box-previews-draggable">
          <div class="d-flex align-items-center">
            <b-avatar :src="preview.preview" square class="avatar-preview-sample" icon="camera-video"></b-avatar>
            <strong class="ml-1">
              <span v-if="preview.name.length > 0">{{preview.name.slice(0, 30)}} <span v-if="preview.name.length > 30"> ...</span></span>
            </strong>
          </div>
          <b-button variant="flat-secondary" @click="deleteFile(preview)">
            <feather-icon icon="TrashIcon" size="20"></feather-icon>
          </b-button>
        </b-col>
      </b-row>

      <div class="d-flex justify-content-end">
        <b-button class="mr-1" variant="light" @click="clearFiles()" v-if="files.length > 0">{{$t('creator.cancel')}}</b-button>
        <b-button :disabled="isSubmitDisabled" class="blue-button" variant="blue-button" @click="uploadContents()">
          <b-spinner class="spinner-waiting-service" v-if="is_uploading"></b-spinner>
          {{$t('creator.submit')}}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BAvatar,
  BButton,
  BFormFile,
  BSpinner,
} from 'bootstrap-vue'
import { getThumbnails } from 'video-metadata-thumbnails';
import chat_service from '@/services/chat';
import utils from '@/libs/utils';
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');

export default {
  name: 'uploadContentsChat',
  components: {
    BRow,
    BCol,
    BAvatar,
    BButton,
    BFormFile,
    BSpinner,
    DealHeaderChat: () => import('@/views/pages/proposals/chat/dealHeaderChat.vue'),
  },
  props: {
    chat: {
      type: Object,
      required: true,
    },
    is_legacy: {
      type: Boolean,
      default: true
    },
    chat_deal: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      text_publish: '',
      change_files: false,
      previews: [],
      file: null,
      files: [],
      generating_preview: false,
      is_uploading: false,
      updated_input: false
    }
  },
  computed: {
    isSubmitDisabled() {
      if (this.is_uploading) return true

      if (this.chat.casting_call) {
        if (this.chat.revisions_remaining === 3) {
          return !this.text_publish || this.files.length === 0
        }
        return !this.text_publish
      }
      
      return this.files.length === 0
    }
  },
  created() {
    const messages = this.chat?.messages || []
    const last_text_publish = messages.findLast(msg => msg.type_message === 'content')
    this.text_publish = last_text_publish?.text || ''
  },
  methods: {
    hasChangeFiles() {
      this.generating_preview = true;
      this.change_files = true;
      this.files.push(this.file)
      const urls_blobs = [];
      setTimeout(() => {
        const url_blob = URL.createObjectURL(this.file);
        const unique_id = utils.getUniqueIndex();
        if (!this.file.type.includes('video')) {
          urls_blobs.push({preview: url_blob, name: this.file.name, id: unique_id});
          this.generating_preview = false
          this.$emit('to_bottom')
        } else {
          this.previews.push({preview: 'is_video', name: this.file.name, id: unique_id});
          const thumbnail = getThumbnails(url_blob, {
            quality: 0.6
          });
          thumbnail.then((value) => {
            const url_blob_thubnail = URL.createObjectURL(value[0].blob);
            this.generating_preview = false
            this.$emit('to_bottom')
            this.previews.map((f) => {
              if (f.id === unique_id) f.preview = url_blob_thubnail
            });
          });
        }
        this.previews = this.previews.concat(urls_blobs);
      },200)
    },
    deleteFile(preview) {
      this.files = this.files.filter((item) => item.name !== preview.name);
      this.previews = this.previews.filter((item) => item.id !== preview.id);
      this.change_files = false;
      this.updated_input = !this.updated_input
    },
    uploadContents() {
      this.is_uploading = true;
      this.generating_preview = true
      const form_data = new FormData();
      if (this.files) {
        this.files.forEach((file) => {
          form_data.append('files', file);
        });
      } else {
        form_data.append('files', null);
      }  
      form_data.append('text', this.text_publish);
      form_data.append('change_files', this.change_files);

      if (this.is_legacy === false) {
        form_data.append('chat_deal_uuid', this.chat_deal.uuid);
      }
      const ws_upload_content = this.is_legacy === false ? chat_service.uploadContentsChatV4(this.chat.uuid, form_data) : chat_service.uploadContentsChat(this.chat.uuid, form_data);

      ws_upload_content.then((response) => {
        if (response?.status === 500) {
          this.is_uploading = false;
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: 'top-right',
              props: {
                title: this.$t('creator.errorContent'),
                icon: 'AlertCircleIcon',
                variant: 'danger',
                text: this.$t('creator.statusRejected')
              }
            })
          })
        } else {
          this.is_uploading = false;
          this.$emit('uploaded_contents', response.results)
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: 'top-right',
              props: {
                title: this.$t('creator.successContentChat'),
                icon: 'CheckCircleIcon',
                variant: 'success',
                text: this.$t('creator.successContentChatText')
              }
            })
          })
        }
        this.updated_input = !this.updated_input
      }).catch(() => {
        this.is_uploading = false;
        this.generating_preview = false;
        loadToastificationContent().then((component) => {
          this.$toast({
            component: component.default,
            position: 'top-right',
            props: {
              title: this.$t('creator.errorContent'),
              icon: 'AlertCircleIcon',
              variant: 'danger',
              text: this.$t('creator.statusRejected')
            }
          })
        })
      })
    },
    clearFiles() {
      this.files = []
      this.previews = []
      this.text_publish = ''
      this.change_files = false
      this.updated_input = !this.updated_input
    }
  },
  watch: {
  }
}
</script>

<style scoped>
.chat-content {
  background-color: #f5f5f5;
}
.size-input{
  width: 100%;
  max-height: 100px;
  resize: none;
  padding: 0.6rem 1rem;  
  border: 1px solid #ccc;
  border-radius: 6px;
  }
.avatar-preview-sample {
  margin-right: 1em;
  width: 45px !important;
  height: 45px !important;
  object-fit: cover !important;
  border-radius: 1em !important;
}
.spinner-waiting-service {
  width: 18px;
  height: 18px;
  margin-right: 0.5em;
}
.card-contents-chats {
  border: 1px solid #ccccccb0;
  border-radius: 1em;
  background: white;
  overflow: hidden;
}
</style>
